import { forwardRef } from 'react';
import { ButtonBase } from '@mui/material';
import { UpDownArrowIcon } from '../UpDownArrowIcon';
import type { UpDownArrowIconProps } from '../UpDownArrowIcon';

type BaseToggleArrowsUpAndDownProps = {
    toggle?: boolean;
    enableRipple?: boolean;
};

export type ToggleArrowsUpAndDownProps = BaseToggleArrowsUpAndDownProps &
    Omit<UpDownArrowIconProps, 'direction'>;

export default forwardRef<SVGSVGElement, ToggleArrowsUpAndDownProps>(
    function ToggleArrowsUpAndDown(
        { toggle = false, enableRipple = false, ...otherProps },
        ref,
    ) {
        const arrow = (
            <UpDownArrowIcon
                ref={ref}
                {...otherProps}
                direction={toggle ? 'up' : 'down'}
            />
        );

        if (enableRipple) {
            return (
                <ButtonBase
                    component="div"
                    centerRipple
                    sx={{
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                    }}
                >
                    {arrow}
                </ButtonBase>
            );
        }
        return arrow;
    },
);
